export const environment = {
  production: false,
  APP_ID: '1ea1028a-1da4-42ea-a803-abc4a2b008b0',
  PROMO: "CH25B1",
  API_BASE_URL: 'https://promo.stg.aws.ual.com/offers/api/acceleratorpromo',
  IMAGE_BASE_URL: 'http://localhost:4200/public/images/',
  ASSETS_BASE_URL: 'http://localhost:4200/public/images/',
};
